import { Outlet } from 'react-router-dom';

import { LiveEnvBanner } from './LiveEnvBanner';
import { MobileSidebarDrawer } from './MobileSidebarDrawer';
import { RouteErrorBoundary } from './RouteErrorBoundary';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function ConsoleLayout() {
    return (
        <div className="flex min-h-screen flex-col bg-background">
            <LiveEnvBanner />
            <div className="flex min-h-0 flex-1">
                <aside
                    aria-label="Primary navigation"
                    className="hidden w-56 shrink-0 border-r border-border bg-background lg:block"
                >
                    <Sidebar />
                </aside>

                <MobileSidebarDrawer />

                <div className="flex min-w-0 flex-1 flex-col">
                    <Topbar />
                    <main className="min-w-0 flex-1">
                        <RouteErrorBoundary>
                            <Outlet />
                        </RouteErrorBoundary>
                    </main>
                </div>
            </div>
        </div>
    );
}
